'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeTypingTimeoutIdForAgentInThread = undefined;

var _reduxActions = require('redux-actions');

var _typingIndicatorActionTypes = require('../constants/typingIndicatorActionTypes');

var removeTypingTimeoutIdForAgentInThread = exports.removeTypingTimeoutIdForAgentInThread = (0, _reduxActions.createAction)(_typingIndicatorActionTypes.REMOVE_AGENT_TYPING_TIMEOUT_ID, function (threadId, agentId) {
  return {
    threadId: threadId,
    agentId: agentId
  };
});